// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__xUVT2","row":"Node_row__1b6-R","label":"Node_label__14lKE","footer":"Node_footer__gYQAc"};